import type React from 'react'
import styled from 'styled-components'
import { theme } from '../../theme/theme'

const StyledActionButton = styled.button<{ $variant?: 'edit' | 'delete' | 'default' }>`
  background: none;
  border: none;
  color: ${({ theme }) => theme.colors.textSecondary};
  cursor: pointer;
  font-size: 20px;
  padding: 0;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: ${theme.transitions.default};

  &:hover {
    background-color: ${({ theme, $variant }) => ($variant === 'delete' ? theme.colors.errorLight : theme.colors.surfaceHover)};
    color: ${({ theme, $variant }) => ($variant === 'delete' ? theme.colors.error : theme.colors.text)};
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`

interface ActionButtonProps {
  variant?: 'edit' | 'delete' | 'default'
  onClick?: (e: React.MouseEvent) => void
  disabled?: boolean
  title?: string
  children: React.ReactNode
}

export const ActionButton: React.FC<ActionButtonProps> = ({
  variant = 'default',
  onClick,
  disabled = false,
  title,
  children,
}) => {
  return (
    <StyledActionButton $variant={variant} onClick={onClick} disabled={disabled} title={title}>
      {children}
    </StyledActionButton>
  )
}
